<template>
    <panel-template :have-padd-g="false">
        <template #bradcrumbs>
            <ui-breadcrumbs design="full" :container="false">
                <template #left>
                    Relatórios &#8226;
                    Relatório Bi 
                    <span class="type-template">{{typeTemplate}}</span>
                </template>
            </ui-breadcrumbs>
        </template>
        <template #content>
            <section>
                <div v-if="load" class="load">
                    <ui-load-indicator
                        bg-color="#e7e9f4"
                        color="#69D296"
                        :h="50"
                        :stroke="8" />
                </div>
                <div class="relatorioButton" >
                    <div class="type-group">
                        <div class="title">
                            Relatório BI - <span class="type-template">{{typeTemplate}}</span>
                        </div>
                        <div class="type-button">
                            <span v-for="pages in page" :key="pages.page" >
                                <ui-button class="md-100 button-larg" :class="{'primary': pages.active, 'light': !pages.active }" @click="setPages(pages.page)" >{{pages.name}}</ui-button>
                            </span>
                        </div>
                        <div class="type-button" >
                            <ui-button class="line-primary" @click="fullscreen()">
                                Tela Cheia
                                <em>
                                    <i class="fal fa-expand" aria-hidden="true"/>
                                </em>
                            </ui-button>
                        </div>
                    </div>
                </div>
                <div class="relatorio">

                    <div v-if="loadBi" class="loadbi">
                        <ui-load-indicator
                            bg-color="#e7e9f4"
                            color="#69D296"
                            :h="50"
                            :stroke="8" />
                    </div>
                    <div id="relatorio-bi"/>
                </div>
            </section>
        </template>
    </panel-template>
</template>

<script>
	import * as pbi                     from "powerbi-client"
	import { powerBi, configuration }   from "@/services/axios"
	import alasql                       from 'alasql'
	import PanelTemplate                from '@/templates/page-panel-center'
	import { storage }                  from '@/services/storage'
	import { uiButton } from '@/components/ui/buttons'
	import { uiBreadcrumbs, uiLoadIndicator}   from '@/components/ui'
	
	export default {
		name: "ui-bi",
		components: {
			PanelTemplate,
			uiBreadcrumbs,
			uiLoadIndicator,
			uiButton
		},

		data() {
			return {
				report: null,
				configurations: null,
				user: null,
				load: true,
				loadBi: false,
				filters: [],
				page: [],
				pages: 'teste',
			}
		},
		computed: {
			typeTemplate: {
				get () {
					return this.$route.params.id
				}
			}
		},
		watch: {
			$route: {
				immediate: true,
				handler(to, from) {
					document.title = (storage.get('client_name') || 'Facilita')
						+ ' - Relatorio BI '
						+ this.typeTemplate[0].toUpperCase()
						+ this.typeTemplate.substr(1)

					if (from) {
						this.page = []
						this.load = true
						this.returnPowerBi()
					}
				}
			}
		},
		mounted() {
			this.returnPowerBi()
			this.user = JSON.parse(storage.get('user_logged'))
		},
		methods: {
			returnPowerBi() {
				configuration.getConfigurations()
					.then(response => {
						let compare
						response.data.map(element => {
							if(element.name == 'configReportsBI') {
								if(element.value_long.reports) {
									compare = Object.keys(element.value_long.reports)
									compare.indexOf(this.typeTemplate) > -1 ? 
									this.setConfig(element.value_long.reports[this.typeTemplate].report, element.value_long.reports[this.typeTemplate]) : 
									this.$router.push({ path: '/erros/nao-autorizado' })
								} else {
									this.$router.push({ path: '/erros/nao-autorizado' })
								}
							}
						})
					})
			},
			setConfig(report, element) {
				powerBi.reports(report).then((res) => {
					let permissions = pbi.models.Permissions.All
					var data = res.data
					//acesso ao powerbi com os dados vindo do banco
					let config = {
						type: 'report',
						tokenType: pbi.models.TokenType.Embed,
						accessToken: data.token,
						embedUrl: data.embedUrl,
						permissions: permissions,
						/**
						* settings trabalha com a estilização do relátorio
						* demais exemplos em:
						* {@link https://docs.microsoft.com/en-us/javascript/api/overview/powerbi/configure-report-settings}
						* {@link https://docs.microsoft.com/en-us/javascript/api/overview/powerbi/custom-layout}
						* links adicionados em 2021 pode sofrer alteraçõs com decorrer do tempo
						**/
						settings: {
							background: pbi.models.BackgroundType.Transparent,
							filterPaneEnabled: false,
							navContentPaneEnabled: false
						}
					}
					var reportContainer = document.getElementById('relatorio-bi')
					// eslint-disable-next-line
					this.report = powerbi.embed(reportContainer, config)
					if (this.report) this.switchLogger(this.user, element)
				})
			},
			switchLogger (user, element) {
				if(user.isDynamicGroup){
					this.filters.push({
						$schema: 'https://powerbi.com/product/schema#basic',
						operator: 'In',
						target:{
							table: 'dados_funil',
							column: 'product_id'
						},
						values: user.group_products ? user.group_products : []
					}) 
				} else {
				//autorização de relátorio por tipo de usuário
					switch(user.user_group){
						case 'admin':
						case 'collaborator':
							break
						case 'supervisor':
							this.filters.push({
								$schema: 'https://powerbi.com/product/schema#basic',
								operator: 'In',
								target:{
									table: 'dados_deal_owners',
									column: 'Equipe'
								},
								values: alasql('SELECT name FROM ? ',[this.user.team])
									.map(item => {
										var empytLastChar = item.name.substr(-1)
										while (empytLastChar == ' '){
											item.name = item.name.substring(0, item.name.length - 1)
											empytLastChar = item.name.substr(-1)
										}
										return item.name
									})
							})
							break
						case 'manager':
							this.filters.push({
								$schema: 'https://powerbi.com/product/schema#basic',
								operator: 'In',
								target:{
									table: 'dados_deal_owners',
									column: 'email_gerente'
								},
								values: [this.user.email]
							})
							break
						case 'broker':
							this.filters.push({
								$schema: 'https://powerbi.com/product/schema#basic',
								operator: 'In',
								target:{
									table: 'dados_deal_owners',
									column: 'email_corretor'
								},
								values: [this.user.email]
							})
							break
					}
				}
				var load = this.report
				// Ao carregar completamente o relatório do powerBi retorna os botões
				load.on('loaded', () => {
					this.setButtons(load, element)
				})
			},
			setPages (pages) {
				this.loadBi = true
				this.page.map(res => {
					res.active = pages == res.page ? true : false
				})
				this.report.setPage(pages).then(()=> {
					setTimeout(() => { 
						this.loadBi = false
					}, 100)
				}) 
			},
			async fullscreen() {
				let newSettings = {
					background: pbi.models.BackgroundType.Default
				}

				await this.report.updateSettings(newSettings)

				this.report.fullscreen()
			},
			setButtons(reports, element) {
				powerBi.launchDay().then((res) => {
					var countLaunchday = res.data
					this.page.splice(0, this.page.length)
					reports.getPages().then(pages => {
						let reportsToShow = element.profiles
						let user = JSON.parse(storage.get('user_logged'))

						let isDinamycToButton = user.isDynamicGroup && reportsToShow['dynamics'] ? reportsToShow['dynamics'] : false
						let userToButtons = reportsToShow[user.user_group] ? reportsToShow[user.user_group] : false
						let isDinamycOrUser = ''

						if (isDinamycToButton) {
							isDinamycOrUser = isDinamycToButton
						}
						
						if (userToButtons) {
							isDinamycOrUser = userToButtons
						}
						this.page = []
						this.newError(user.isDynamicGroup, reportsToShow, user.user_group, isDinamycToButton) 
							pages.map(page => {
								//gera botões de acordo com o tipo de usuário
								if((isDinamycOrUser.indexOf(page.displayName) > -1) && (page.displayName != 'Lançamentos' || page.displayName == 'Lançamentos' && countLaunchday > 0)) {
									this.page.push({name: page.displayName, page: page.name, active: page.isActive})
									this.load = false
								}
							})
					})
				})
				//retorna os filtros do switch e faz a seleção das paginas
				reports.setFilters(this.filters).then(() => {
					console.log('Report filter was set.')
				}).catch(function (errors) {
					console.log(errors)
				})
				//se existir algum erro, fecha a entrada do relatório.
				reports.on('rendered')
					reports.on('error', function () {
					reports.off('error')
				})
			},
			newError (isDynamic, reportToShow, group, isDinamycToButton) {
				if(isDynamic && !isDinamycToButton) {
					this.$router.push({ path: '/erros/nao-autorizado' })
					return false
				}
				if(!isDynamic && !reportToShow[group]) {
					this.$router.push({ path: '/erros/nao-autorizado' })
					return false
				}

				return true
			}
			
		}
	}
</script>
<style lang='stylus' scoped>
	@import './styles.styl'
</style>
